import { DatasetChartProps } from "../charts/interfaces";

export enum LineEditorLoadingTypes {
  TIME = "Time",
  PRODUCT_ENTRY = "Product Entry",
}

export enum LoadConfigUnitTypes {
  LAGUNIT = "lagUnit",
  LEADUNIT = "leadUnit",
  ALIGNUNIT = "alignUnit",
}

export const defaultLoadConf = {
  type: LineEditorLoadingTypes.TIME,
  lead: 0,
  lag: 6,
  leadUnit: "HOURS",
  lagUnit: "HOURS",
  alignUnit: "MINUTES",
};

export const defaultDatasetLineChartConfig: DatasetChartProps = {
  height: 400,
  showDateSelection: true,
  hideRefresh: false,
  loadConf: defaultLoadConf,
  updateFrequency: 5,
  datasets: [],
  toggleTracesGrouping: true,
  timeAxisStepSeconds: 0,
};